import type { ReactNode } from 'react'
import styles from './Bandeau.module.css'

export type TonBandeau = 'erreur' | 'alerte' | 'succes' | 'info'

/**
 * Le symbole double la couleur. Une information portée par la seule teinte
 * est invisible pour un daltonien et disparaît à l'impression
 * (skill `design-system-afs`).
 */
const SYMBOLE: Readonly<Record<TonBandeau, string>> = {
  erreur: '!',
  alerte: '!',
  succes: '✓',
  info: 'i',
}

const ROLE: Readonly<Record<TonBandeau, 'alert' | 'status'>> = {
  erreur: 'alert',
  alerte: 'status',
  succes: 'status',
  info: 'status',
}

interface ProprietesBandeau {
  readonly ton: TonBandeau
  readonly titre?: string | undefined
  /**
   * Référence à afficher au support : code de règle métier (`RG-*`) ou
   * identifiant de requête. Sans elle, un incident n'est pas retrouvable
   * dans les logs serveur.
   */
  readonly reference?: string | undefined
  readonly children: ReactNode
}

export function Bandeau({ ton, titre, reference, children }: ProprietesBandeau): React.JSX.Element {
  return (
    <div className={`${styles.bandeau} ${styles[ton]}`} role={ROLE[ton]}>
      <span className={styles.symbole} aria-hidden="true">
        {SYMBOLE[ton]}
      </span>
      <div className={styles.contenu}>
        {titre && <span className={styles.titre}>{titre}</span>}
        <span>{children}</span>
        {reference && <span className={styles.reference}>Référence : {reference}</span>}
      </div>
    </div>
  )
}
